import { Route } from '@angular/router';
import { GameMode } from '@dc-core/dc-backend/dc-enums';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const randomCheckoutLocalGameRoutes: Route[] = [
    {
        path: 'local-games/random-checkout',
        loadComponent: () =>
            import('./pages/random-checkout-new-game/random-checkout-new-game.component').then(
                (c) => c.RandomCheckoutNewGameComponent
            ),
    },
    {
        path: 'game/random-checkout',
        data: {
            gameMode: 'random_checkout' as GameMode,
        },
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/random-checkout-local-game-app/random-checkout-local-game-app.component').then(
                (c) => c.RandomCheckoutLocalGameAppComponent
            ),
    },
];

export const randomCheckoutVenueLocalGameRoutes: Route[] = [...randomCheckoutLocalGameRoutes];
